import React from 'react';

import { RamechhapFAQ, CommonFAQ, ImportantNotice } from '../SearchAndResults/StaticSections';
import { subTitle,  sectors, appendStatic } from './common';

const pageTitle = 'Ramechhap to Lukla Flight at USD 144*';

const ramechhap = {
  pageTitle,
  subTitle,
  CreditMessage: () => (
    <p className="ext-word">
      * Transportation between Kathmandu and Ramechhap is included in the same price for people who book flights directly through HoneyGuide's website. <br/>
      * We are also offering transport between Kathmandu & Ramechhap at USD 15. For booking <a href='https://honeyguideapps.com/transportation' style={{ color: '#00C0FF', textShadow: 'rgba(0, 0, 0, 1) 0px 0px 5px', fontWeight: '700'  }} rel="noopener noreferrer" target="_blank">Click Here</a>.
    </p>
  ),
  seo: {
    title: appendStatic(pageTitle),
    description:
      'Get upto USD 5 Credits with each ticket. 24x7 hours support from people who know the mountains. 72 hours Free Cancellation. Online Flight Booking between Ramechhap and Lukla',
    image:
      'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  from: 'RHP',
  to: 'LUA',
  sectors,
  Notice: () => <ImportantNotice />,
  valueProps: [
    'Price Match Guarantee',
    'Free 24 hours cancellation',
    '24x7 support from HoneyGuide',
  ],
  Faq: () => {
    return (
      <React.Fragment>
        <RamechhapFAQ/>
        <CommonFAQ />
      </React.Fragment>
    )
  },
  pricesToCompare:  [
    { url: 'https://honeyguide.s3.amazonaws.com/assets/yeti-air2.png', price: 'USD 127.3', subText: '*Without Transport.' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/nepal-cheap-flights.png', price: 'USD 165', subText: '*Include Transport.' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/kathmandu-lukla-flight.png', price: 'USD 165', subText: '*Include Transport.' },
  ],
};

export default ramechhap;



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/ramechhap.js